import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import { useAdminRole } from '../context/AdminRoleContext';

const NAV_ITEMS: { to: string; label: string; adminOnly?: boolean }[] = [
  { to: '/admin', label: 'Dashboard' },
  { to: '/admin/funil', label: 'Funil' },
  { to: '/admin/campanhas', label: 'Campanhas' },
  { to: '/admin/marketing', label: 'Marketing' },
  { to: '/admin/conversas', label: 'Conversas' },
  { to: '/admin/pix-pendentes', label: 'PIX', adminOnly: true },
  { to: '/admin/gerar-link', label: 'Gerar link', adminOnly: true },
];

export default function AdminHeader({ title }: { title?: string }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const role = useAdminRole();
  const isViewer = role === 'viewer';
  const navItems = NAV_ITEMS.filter((item) => !item.adminOnly || !isViewer);

  const handleLogout = async () => {
    await fetch('/api/admin-login', { method: 'DELETE', credentials: 'same-origin' });
    window.location.href = '/admin';
  };

  return (
    <header
      style={{
        padding: '12px 20px',
        borderBottom: '1px solid var(--border-soft)',
        background: 'var(--surface-white)',
        backdropFilter: 'blur(16px) saturate(1.05)',
        WebkitBackdropFilter: 'blur(16px) saturate(1.05)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        flexShrink: 0,
        flexWrap: 'wrap',
        position: 'sticky',
        top: 0,
        zIndex: 50,
        boxShadow: '0 1px 0 rgba(255,255,255,0.04) inset, 0 6px 24px rgba(120,70,30,0.05)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
        <Link to="/admin" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <img src="/inspira-favicon.png" alt="Inspira" style={{ height: 30, width: 30 }} />
          <span
            style={{
              fontWeight: 800,
              fontSize: 14,
              letterSpacing: '-0.02em',
              color: 'var(--heading-ink)',
              whiteSpace: 'nowrap',
            }}
          >
            {title || 'Admin'}
          </span>
        </Link>
        {isViewer && (
          <span
            title="Acesso de visualização (gestor de tráfego) — somente leitura"
            style={{
              padding: '3px 10px',
              borderRadius: 999,
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.02em',
              background: 'var(--badge-bg)',
              color: 'var(--text-strong)',
              border: '1px solid var(--border-soft)',
              whiteSpace: 'nowrap',
            }}
          >
            Visualização
          </span>
        )}
      </div>

      <nav style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
        {navItems.map((item) => {
          const active =
            item.to === '/admin'
              ? currentPath === '/admin' || currentPath === '/admin/' || currentPath === '/admin/dashboard'
              : currentPath.startsWith(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              style={{
                padding: '6px 14px',
                borderRadius: 999,
                fontSize: 13,
                fontWeight: 600,
                textDecoration: 'none',
                background: active ? 'var(--gold)' : 'var(--badge-bg)',
                color: active ? 'var(--gold-ink)' : 'var(--text-strong)',
                border: '1px solid',
                borderColor: active ? 'var(--gold)' : 'var(--border-soft)',
                whiteSpace: 'nowrap',
                fontFamily: 'inherit',
                transition: 'background 0.18s, box-shadow 0.18s, transform 0.18s',
                boxShadow: active ? '0 4px 14px rgba(255,108,108,0.34)' : 'none',
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <ThemeToggle />
        <button
          onClick={handleLogout}
          title="Sair"
          aria-label="Sair"
          style={{
            padding: '6px 12px',
            borderRadius: 999,
            background: 'var(--badge-bg)',
            border: '1px solid var(--border-soft)',
            color: 'var(--text-strong)',
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          Sair
        </button>
      </div>
    </header>
  );
}
